export default __webpack_public_path__ + "static/media/not-found-sm.3b508884.png";